export default class SpecialistCertificateController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistCertificate/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistCertificate/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/specialistCertificate/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistCertificate/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistCertificate/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistCertificate/delete', 'post', params, axiosOption, httpOption);
  }

  static batchRegenerate (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistCertificate/batchRegenerate', 'post', params, axiosOption, httpOption);
  }
}
